import { createSelector } from 'reselect'

import * as pointsSelectors from './points'

export const gradingVisibleSelector = createSelector(
  pointsSelectors.gradingEnabledSelector,
  pointsSelectors.gradingPeriodsLengthSelector,
  pointsSelectors.freeformPointsActiveSelector,
  pointsSelectors.freeformPointsGradingVisibleSelector,
  (
    gradingEnabled,
    gradingPeriodsLength,
    freeformPointsActive,
    freeformPointsGradingVisible
  ) =>
    Boolean(
      gradingEnabled &&
        gradingPeriodsLength &&
        (!freeformPointsActive || freeformPointsGradingVisible)
    )
)
